import { ComputeEngine } from '@cortex-js/compute-engine';
import { StudyStep, StudyItemType } from '@asset/enum/problemSolvingEnum';
import { StudyContentType } from '@asset/enum/materialEnum';
import { ElementarySchoolMathCourse, EtcCourse, HighSchoolMathCourse, MiddleSchoolMathCourse } from '@asset/enum/materialEnum';
import { getMaterialFilterList } from '@apis/api/manageStudyMaterial';
import { ReportContentType, StudyPurpose } from '@asset/enum/enum';
import { getStudyHistories } from '@apis/api/studentStudyContent';
import { PhoneNumberUtil } from 'google-libphonenumber';
import _ from 'lodash';
import { StudyReportSlide } from 'routes/studyReport';
import { DateTime } from 'luxon';
import { StudyStatus } from '@asset/enum/studyStatus';
import { KST } from 'constants/time';
export const translateStudyStatus = textList => {
  const studyStatusText = {
    'main-study': '본학습',
    'first-review': '복습1',
    'second-review': '복습2',
    description: '설명하기'
  };
  let result = '';
  textList?.map(text => {
    result += studyStatusText[text] + ', ';
  });
  return result.slice(0, -2);
};
export const getProblemStudySteps = () => {
  return [StudyStep.FIRST_SOLVING, StudyStep.SECOND_SOLVING, StudyStep.TAKING_LECTURE, StudyStep.REVIEW_NOTE, StudyStep.FIRST_REVIEW, StudyStep.SECOND_REVIEW];
};
export const getConceptStudySteps = () => {
  return [StudyStep.FIRST_SOLVING, StudyStep.FIRST_REVIEW, StudyStep.SECOND_REVIEW];
};

// [34, 35] 형태의 array 로 오면 => 34-35 형태의 string 반환
export const convertPageListToText = (pageRange, simplify) => {
  if (!Array.isArray(pageRange) || pageRange.length === 0) {
    return '';
  }
  if (simplify) {
    if (pageRange.length > 1) {
      return `${pageRange[0]} ~ ${pageRange[pageRange.length - 1]}`;
    } else {
      return `${pageRange[0]}`;
    }
  }
  const firstPageArray = [];
  const lastPageArray = [];
  let bool = 0;
  let idx = 0;
  firstPageArray.push(parseInt(pageRange[0]));
  while (idx < pageRange.length) {
    const currentNum = parseInt(pageRange[idx]);
    const nextNum = parseInt(pageRange[idx + 1]);
    if (currentNum + 1 === nextNum) {
      if (bool === 0 && firstPageArray.indexOf(currentNum) === -1) {
        firstPageArray.push(currentNum);
      }
      bool = 1;
      idx++;
      continue;
    } else {
      if (bool === 0 && firstPageArray.indexOf(currentNum) === -1) {
        firstPageArray.push(currentNum);
      }
      lastPageArray.push(currentNum);
      bool = 0;
      idx++;
      continue;
    }
    idx++;
  }
  let pageText = '';
  firstPageArray.forEach((element, index) => {
    if (element === lastPageArray[index]) {
      pageText += element + ', ';
    } else {
      pageText += element + '-' + lastPageArray[index] + ', ';
    }
  });
  if (pageText === 'NaN-undefined, ') {
    pageText = '';
  } else if (pageText.length > 2) {
    pageText = pageText.slice(0, -2);
  }
  return pageText;
};
export const convertNumberToTime = (timeNumber, locale = 'ko') => {
  const min = Math.floor(timeNumber / 60);
  const sec = timeNumber % 60;
  return locale == 'ko' ? `${min}분 ${sec}초` : `${min}m ${sec}s`;
};
export const timeFormat = (totalSeconds, maxCharLength = 2, fractionDigits = 0, formatParamObj = {
  hour: '시간',
  minute: '분',
  second: '초'
}, hideFormattedSecond = true, displayZeroAsHours = true) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds - hours * 3600) / 60);
  const remainingSeconds = totalSeconds - hours * 3600 - minutes * 60;
  const formattedHours = String(hours).padStart(maxCharLength, '0');
  const formattedMinutes = String(minutes).padStart(maxCharLength, '0');
  const formattedSeconds = String(remainingSeconds.toFixed(fractionDigits)).padStart(maxCharLength, '0');
  const durationFormat = formattedHours + ':' + formattedMinutes + ':' + formattedSeconds;
  let timeTextFormat = '';
  if (totalSeconds === 0) {
    if (displayZeroAsHours) timeTextFormat = '0' + formatParamObj.hour;else if (formatParamObj?.second) timeTextFormat = '0' + formatParamObj.second;else timeTextFormat = '0' + formatParamObj.minute;
  } else {
    if (formatParamObj?.hour && Number(formattedHours) !== 0) timeTextFormat += formattedHours + formatParamObj?.hour + ' ';
    if (formatParamObj?.minute && Number(formattedMinutes) !== 0) timeTextFormat += formattedMinutes + formatParamObj?.minute + ' ';
    if (formatParamObj?.second && Number(formattedSeconds) !== 0 && !hideFormattedSecond) timeTextFormat += formattedSeconds + formatParamObj?.second + ' ';
    timeTextFormat = timeTextFormat.slice(0, -1);
  }
  return {
    durationFormat,
    timeTextFormat,
    formattedHours,
    formattedMinutes,
    formattedSeconds
  };
};
export const latexToMathJson = (latex, splitChar = ',') => {
  const ce = new ComputeEngine();
  const list = latex.replaceAll(' ', '').split(splitChar);
  const result = [];
  list.map(value => {
    if (value) {
      const rawMath = ce.parse(value);
      if (!rawMath || !rawMath.json) result.push('');
      let rawMathJson = rawMath?.json;
      const expandMathJson = ce.box(['Expand', rawMath]).evaluate().json;
      if (expandMathJson !== 'False') {
        rawMathJson = expandMathJson;
      }
      if (rawMath?.isValid) {
        if (!Array.isArray(rawMathJson)) {
          rawMathJson = [rawMathJson];
        }
        if (JSON.stringify(rawMathJson).includes('Error')) {
          result.push(['']);
        } else result.push([JSON.stringify(rawMathJson)]);
      } else {
        result.push(['']);
      }
    }
  });
  return result;
};
export const getMathJson = (answerObj, splitChar = ',') => {
  const answerMathJson = {};
  const keyList = Object.keys(answerObj);
  for (const element of keyList) {
    if (answerObj[element]) {
      answerMathJson[element] = latexToMathJson(answerObj[element], splitChar);
    } else {
      answerMathJson[element] = null;
    }
  }
  return answerMathJson;
};
export const timeStampToDateTime = (timestamp, timezone = KST) => {
  if (_.isNil(timestamp)) return null;
  const targetDate = DateTime.fromSeconds(timestamp, {
    zone: timezone
  });
  const today = DateTime.now().setZone(timezone);
  const date = targetDate.toFormat('M월 d일');
  const time = targetDate.toFormat('HH:mm');
  const todayMidnight = today.startOf('day');
  const targetDateMidnight = targetDate.startOf('day');
  const daysAgo = todayMidnight.diff(targetDateMidnight, ['days', 'hours']).toObject().days;
  return {
    date,
    time,
    daysAgo
  };
};
export const changeKeyName = (objectList, previousKeyNameList, changedKeyNameList) => {
  const newList = [];
  objectList.map(valueObject => {
    const newObj = {
      ...valueObject
    };
    previousKeyNameList.map((prevKeyName, keyIndex) => {
      newObj[changedKeyNameList[keyIndex]] = valueObject[prevKeyName];
      delete newObj[prevKeyName];
    });
    newList.push(newObj);
  });
  return newList;
};
export const getHoursFromSeconds = (seconds, length = 1) => {
  const hour = Math.floor(seconds / 3600);
  if (hour > 0) {
    if (length == 1) {
      return hour;
    } else {
      return hour > 9 ? `0${hour}` : hour;
    }
  } else {
    return false;
  }
};
export const getMinutesFromSeconds = (seconds, length = 1) => {
  const hours = Math.floor(seconds / 3600);
  const minute = Math.floor((seconds - hours * 3600) / 60);
  if (minute > 59) {
    if (length == 1) {
      return minute % 60;
    } else {
      return minute % 60 > 9 ? minute % 60 : `0${minute % 60}`;
    }
  } else {
    if (length == 1) {
      return minute;
    } else {
      return minute > 9 ? minute : `0${minute}`;
    }
  }
};
export const getClassificationNameText = classificationObj => {
  let text = '';
  if (classificationObj?.chapterIdx) text += `${classificationObj.chapterIdx}.`;
  if (classificationObj?.sectionIdx) text += `${classificationObj.sectionIdx}.`;
  if (classificationObj?.subsectionIdx) text += `${classificationObj.subsectionIdx}.`;
  if (classificationObj?.subsectionName) text += ` ${classificationObj.subsectionName}`;else if (classificationObj?.sectionName) text += ` ${classificationObj.sectionName}`;else if (classificationObj?.chapterName) text += ` ${classificationObj.chapterName}`;
  return text;
};
export const getStartToEndClassificationName = (startClassification, endClassification) => {
  let resultText = '';
  const startClassificationName = getClassificationNameText(startClassification);
  const endClassificationName = getClassificationNameText(endClassification);
  if (startClassificationName === endClassificationName) {
    if (startClassificationName === '') {
      resultText = '-';
    } else resultText = startClassificationName;
  } else {
    resultText = `${startClassificationName} ~ ${endClassificationName}`;
  }
  return resultText;
};
export const getPageTypeFromStudyContentType = type => {
  if (type === StudyContentType.MY_STUDY_MATERIAL) {
    return StudyContentType.MY_STUDY_MATERIAL;
  } else if (type === StudyContentType.MY_ASSIGNMENT) {
    return StudyContentType.MY_ASSIGNMENT;
  } else if (type === StudyContentType.MY_TEST || type === StudyContentType.MY_WRONG_TEST || type === StudyContentType.MY_LEVEL_TEST) {
    return StudyContentType.MY_TEST;
  }
};
export const getMissionPurposeTranslationKey = purpose => {
  const map = {
    [StudyPurpose.MAIN_STUDY]: 'common:StudyPurpose.mainStudy',
    [StudyPurpose.DESCRIPTION]: 'common:StudyPurpose.explain'
  };
  return map[purpose];
};
export const hasMultipleCourse = studyContentInfo => {
  if (studyContentInfo) {
    const courseList = [];
    studyContentInfo.materials?.map(material => {
      if (material.course && !courseList.some(course => course === material.course)) {
        courseList.push(material.course);
      }
    });
    return courseList.length > 1 ? true : false;
  }
  return false;
};
export const getMaterialCourse = (studyContentInfo, t) => {
  return hasMultipleCourse(studyContentInfo) ? t('common:course.integrated') : studyContentInfo.materials && studyContentInfo.materials[0]?.course ? studyContentInfo.materials[0]?.course : '';
};
export const sortObjectArrayByCourseOrder = (objectArray, courseValueKeyName) => {
  const courseOrder = [...Object.values(MiddleSchoolMathCourse), ...Object.values(HighSchoolMathCourse), ...Object.values(ElementarySchoolMathCourse), ...Object.values(EtcCourse)];
  objectArray.sort((a, b) => courseOrder.indexOf(a[courseValueKeyName]) - courseOrder.indexOf(b[courseValueKeyName]));
  return objectArray;
};
export const getListFiltering = async () => {
  const data = await getMaterialFilterList();
  const filterSubjectList = [...new Set(data.map(obj => {
    return {
      value: obj['subject'],
      label: obj['subject']
    };
  }))].filter((arr, index, callback) => index === callback.findIndex(t => t.value === arr.value));
  const filterCourseList = [...new Set(data.map(obj => {
    return {
      value: obj['course'],
      label: obj['course']
    };
  }))].filter((arr, index, callback) => index === callback.findIndex(t => t.value === arr.value));
  return {
    filterSubjectList,
    filterCourseList
  };
};
export const addStudyHistoryInContentValues = async (contentValues, studentId) => {
  const _contentValues = JSON.parse(JSON.stringify(contentValues));
  const pageIds = [];
  _contentValues.map(ps => pageIds.push(ps.pageId));
  const historiesResponse = await getStudyHistories(pageIds, studentId);
  historiesResponse.histories.map((history, index) => {
    _contentValues[index]['studyHistory'] = history;
  });
  return _contentValues;
};
const phoneUtil = PhoneNumberUtil.getInstance();
export const isValidPhoneNumber = phone => {
  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  } catch (error) {
    return false;
  }
};
export const validatePhoneNumberField = (value, required = false) => {
  const isEmpty = _.isNil(value) || _.isNil(value) === null || value.replaceAll(' ', '') === '';
  if (required && !isEmpty && isValidPhoneNumber(value) || !required && (isEmpty || isValidPhoneNumber(value))) return true;else return false;
};
export const covertCamelToSnake = str => {
  return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
};
export const getReportContentTypeFromReportUrl = pathname => {
  if (pathname.includes(StudyReportSlide.STUDY_TIME)) {
    return ReportContentType.STUDY_TIME;
  } else if (pathname.includes(StudyReportSlide.STUDY_RECORDS)) {
    return ReportContentType.STUDY_RECORD;
  } else if (pathname.includes(StudyReportSlide.COURSE_DETAIL)) {
    return ReportContentType.ON_GOING_COURSE;
  } else if (pathname.includes(StudyReportSlide.TEST_RESULTS)) {
    return ReportContentType.TEST_RECORD;
  } else {
    return null;
  }
};
export const urlToFileObject = async image => {
  const response = await fetch(image);
  const blob = await response.blob();
  const file = new File([blob], 'image.jpg', {
    type: blob.type
  });
  return file;
};
export const getStudentStudyStatusText = ({
  solvedAt,
  elapsedTime,
  studyItemType
}) => {
  let timeText = '최근 활동 없음';
  let statusText = null;
  if (_.isNil(solvedAt)) {
    return {
      timeText,
      statusText
    };
  }
  const diffNow = solvedAt.diffNow(['minutes', 'hours', 'days']).toObject();
  const diffMinFromNow = diffNow.minutes * -1;
  const diffHourFromNow = diffNow.hours * -1;
  const diffDayFromNow = diffNow.days * -1;
  const elapsedMin = elapsedTime / 60;
  const isStudying = diffDayFromNow === 0 && diffHourFromNow === 0 && diffMinFromNow < 5;
  if (isStudying) {
    timeText = `${Math.floor(elapsedMin)}분 째`;
  } else {
    if (1 <= diffHourFromNow) {
      if (diffDayFromNow < 1) {
        timeText = `${Math.floor(diffHourFromNow)}시간 전`;
      } else if (diffDayFromNow < 7) {
        timeText = `${Math.floor(diffDayFromNow)}일 전`;
      } else if (7 <= diffDayFromNow) {
        timeText = `최근 활동 없음`;
      }
    } else {
      timeText = `${Math.floor(diffMinFromNow)}분 전`;
    }
  }
  if (diffDayFromNow <= 7) {
    statusText = studyItemType === StudyItemType.PROBLEM ? '문제 풀이' : studyItemType === StudyItemType.CONCEPT ? '강의수강' : studyItemType === StudyItemType.READING_MATERIALS ? '교재학습' : null;
  }
  return {
    timeText,
    statusText
  };
};
export const getStudentStudyStatus = (isAnomalous, isActive) => {
  if (isAnomalous) return StudyStatus.WARNING;
  if (isActive) return StudyStatus.ACTIVE;
  return StudyStatus.INACTIVE;
};